import { render } from "./ProjectDataTable.vue?vue&type=template&id=9886e8f8&scoped=true"
import script from "./ProjectDataTable.vue?vue&type=script&lang=js"
export * from "./ProjectDataTable.vue?vue&type=script&lang=js"

import "./ProjectDataTable.vue?vue&type=style&index=0&id=9886e8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9886e8f8"]])

export default __exports__